<div class="card card-info card-outline">
    <div class="card-header">
        <p class="card-title"><i class="fas fa-warehouse"></i> ข้อมูลแผนก</p>
        <div class="card-tools text-primary ">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
            <div class="col-4">
                <form #frm_addDep="ngForm"
                    (ngSubmit)="saveAddDep(frm_addDep.value); frm_addDep.resetForm()"novalidate>
                    <div class="card card-primary card-outline">
                        <div class="card-header">
                            <h3 class="card-title text-primary"><i class="fas fa-plus-circle"></i> เพิ่มข้อมูลแผนก</h3>
                        </div>
                        <div class="card-body">
                                <div class="form-group row">
                                    <label for="dep_id" class="col-sm-2 col-form-label">รหัสแผนก</label>
                                    <div class="col-sm-10">
                                        <input #dep_id="ngModel" ngModel name="dep_id" class="form-control" placeholder="ป้อนรหัสแผนก4หลัก"
                                        required [ngClass]="{ 'is-invalid' : dep_id.invalid && (dep_id.dirty || dep_id.touched )}"
                                        minlength="4" maxlength="4" (keypress)="numberOnly($event)"
                                        [(ngModel)]="depEdit.dep_id">
                                        <div class="invalid-feedback">
                                            <span *ngIf="dep_id.hasError('required')">กรุณาป้อนรหัสแผนก4หลัก</span>
                                            <span *ngIf="dep_id.hasError('minlength')">กรุณาป้อนรหัสแผนก4หลัก</span>
                                            <span *ngIf="dep_id.hasError('maxlength')">กรุณาป้อนรหัสแผนก4หลัก</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="dep_name" class="col-sm-2 col-form-label">ชื่อแผนก</label>
                                    <div class="col-sm-10">
                                        <input #dep_name="ngModel" ngModel name="dep_name" class="form-control" placeholder="ป้อนชื่อแผนก"
                                        required [ngClass]="{ 'is-invalid' : dep_name.invalid && (dep_name.dirty || dep_name.touched )}"
                                        [(ngModel)]="depEdit.dep_name">
                                        <div class="invalid-feedback">
                                            <span *ngIf="dep_name.hasError('required')">กรุณาป้อนรหัสแผนก4หลัก</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="supzone" class="col-sm-2 col-form-label">โซน</label>
                                    <div class="col-sm-10">
                                        <input #supzone="ngModel" ngModel name="supzone" class="form-control" placeholder="กรณีเป็นโซนส่งเสริม"
                                        [(ngModel)]="depEdit.supzone">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="partcode" class="col-sm-2 col-form-label">ส่วน</label>
                                    <div class="col-sm-10">
                                        <select #partcode="ngModel" ngModel name="partcode" class="form-control"
                                        required [ngClass]="{ 'is-invalid' : partcode.invalid && (partcode.dirty || partcode.touched )}"
                                        [(ngModel)]="depEdit.partcode">
                                            <option selected>++เลือกส่วน++</option>
                                            <option [value]="item.partcode" *ngFor="let item of partData">{{ item.partname }} </option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <span *ngIf="partcode.hasError('required')">กรุณาเลือกส่วน</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="faction" class="col-sm-2 col-form-label">ฝ่าย</label>
                                    <div class="col-sm-10">
                                        <select #faction="ngModel" ngModel name="faction" class="form-control"
                                        required [ngClass]="{ 'is-invalid' : faction.invalid && (faction.dirty || faction.touched )}"
                                        [(ngModel)]="depEdit.faction">
                                            <option selected>++เลือกฝ่าย++</option>
                                            <option [value]="item.faction" *ngFor="let item of factionData">{{ item.faction_name }} </option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <span *ngIf="faction.hasError('required')">กรุณาเลือกฝ่าย</span>
                                        </div>
                                    </div>
                                </div>
                                <input #dataid="ngModel" ngModel name="dataid" type="hidden" [(ngModel)]="depEdit.dataid">
                        </div>
                        <div class="card-footer">
                            <!-- {{ frm_addDep.value | json }} -->
                            <div class="btn-group btn-group-md">
                                <button type="submit" class="btn btn-info" 
                                    [disabled]="frm_addDep.invalid || formEdit">เพิ่มข้อมูล</button>
                                <button (click)="saveEditDep(frm_addDep.value)" 
                                    type="button" class="btn btn-warning ml-1" 
                                    *ngIf="formEdit">แก้ไขข้อมูล</button>
                                <!-- <button type="button" class="btn btn-danger ml-1" 
                                    *ngIf="formEdit">ลบข้อมูล</button>  -->
                                <button (click)="formReset()" type="reset" class="btn btn-secondary ml-1">กรอกใหม่</button> 
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-8">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title text-primary"><i class="fas fa-warehouse"></i> ข้อมูลแผนก</h3>
                        <button (click)="depList()" type="button" class="btn btn-link" data-toggle="tooltip" title="Refresh">
                            <i class="fa fa-rotate-right"></i></button>
                        <div class="card-tools">
                            <!-- <span data-toggle="tooltip" title="3 New Messages" class="badge bg-primary">3</span> -->
                            <button (click)="depList()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Refresh">
                                <i class="	fas fa-circle-notch"></i></button>
                            <button (click)="exportDep()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Download Excel">
                                    <i class="	fas fa-file-excel"></i></button>
                            <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body table-responsive p-2" style="height: 400px">
                        <table #tb_data class="table table-hover table-head-fixed text-nowrap" id="dep-table">
                            <thead>
                                <tr class="text-primary">
                                    <th>รหัสแผนก</th>
                                    <th>ชื่อแผนก</th>
                                    <th>โซน</th>
                                    <th>ส่วน</th>
                                    <th>ฝ่าย</th>
                                    <th class="text-center"><i class="fas fa-bars"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="editDep(item.dataid)" *ngFor="let item of depData">
                                    <td>{{ item.dep_id }}</td>
                                    <td>{{ item.dep_name }}</td>
                                    <td>{{ item.supzone }}</td>
                                    <td>{{ item.partcode_doc }}</td>
                                    <td>{{ item.faction_name }}</td>
                                    <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                                    <td class="text-center text-primary align-middle">
                                        <a (click)="modalUpdataaudit(item.dataid)" data-bs-toggle="modal"
                                            data-bs-target="#explan_plant">
                                            <i class="fas fa-edit"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
</div>
